const icons = {
    admin_users: <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-user-shield">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
        <path d="M6 21v-2a4 4 0 0 1 4 -4h2"/>
        <path d="M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"/>
        <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"/>
    </svg>,
    report_user :<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-person-lines-fill" viewBox="0 0 16 16">
    <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"/>
  </svg>
}

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const adminList = {
    id: 'admin',
    title: 'User management',
    type: 'group',
    role: [0],
    children: [
        {
            id: '/admin/list',
            title: 'Admin',
            type: 'item',
            url: '/admin/list',
            icon: icons.admin_users,
            role: [0],
            breadcrumbs: false
        },
    ]
};

export default adminList;